module.exports = __webpack_public_path__ + "img/12.dd519b65.png";